<template>
  <div class="ui-content">
    <div class="ui-box">
      <el-form ref="form" class="ui-box-from-motherDetail" label-position="right" :model="form" label-width="150px">
        <baseInfo :data.sync="form"></baseInfo>
        <recordInfo :data.sync="form"></recordInfo>
        <babyInfo v-if="form.currentGeneration === 2" :data.sync="form" :baby.sync="form.tbBabyInfo"></babyInfo>
        <riskInfo :data.sync="form" :riskTree="riskTree"></riskInfo>
        <healthInfo v-if="form.healthlVo" :data.sync="form" :healthlVo.sync="form.healthlVo"> </healthInfo>
      </el-form>
    </div>
  </div>
</template>

<script>
let suffixList = '';
let fileName = '';
const controller = 'user';
let parentName = '';
import cal from '@/utils/calculation';
import { mapGetters } from 'vuex';
import babyInfo from '@/components/patient/babyInfo'
import baseInfo from '@/components/patient/baseInfo'
import recordInfo from '@/components/patient/recordInfo'
import riskInfo from '@/components/patient/riskInfo'
import healthInfo from '@/components/patient/healthInfo'
export default {
  name: `patientDetail`,
  props: {
    isMy: Boolean,
  },
  mounted () {
    suffixList = this.isMy ? ['patient', 'my'] : ['patient', 'hospital']
    fileName = `${this.isMy ? 'myDetail' : 'hospitalDetail'}`
    parentName = `${this.isMy ? '我的患者列表' : '全院患者列表'}`
    this.fileName = fileName
    this.filePath = ['', ...suffixList, fileName].join('/')
    this.pathCode = `${suffixList.join('')}${fileName}`
  },
  data () {
    const _this = this;
    return {
      pathCode: '',
      loading: false,
      filePath: '',
      fileName: fileName,
      form: {
        cardiacDevices: [],
        jaundiceDevices: []
      },
      originRiskTree: [],
      riskTree: [],
    };
  },
  computed: {
    isSee () {
      return false;
    },
    pageType () {
      return 'edit';
    },
    ...mapGetters(['lastBreadCrumb', 'refreshPage'])
  },
  watch: {
    $route (to, from) {
      if (to.path === this.filePath && this.refreshPage) {
        this.init();
        this.$store.dispatch('setRefreshPage', false);
      }
    }
  },
  methods: {
    clear () {
      this.form = {
        cardiacDevices: [],
        jaundiceDevices: []
      };
    },
    init () {
      this.clear();
      this.getById(this.$route.query.tbId);
    },
    initForm (form) {
      if (form.birthday) {
        form.birthday = form.birthday ? new Date(form.birthday.replace(/-/g, '/')).format('yyyy-MM-dd') : '-'
      }
      if (form.prepareProduction) {
        form.prepareProduction = form.prepareProduction ? new Date(form.prepareProduction.replace(/-/g, '/')).format('yyyy-MM-dd') : '-'
      }
      if (form.babyBornTime) {
        form.babyBornTime = form.babyBornTime ? new Date(form.babyBornTime.replace(/-/g, '/')).format('yyyy-MM-dd') : '-'
      }
      form.tbNativePlace = null
      if (form.tbNativePlaceAreaName) {
        form.tbNativePlace = form.tbNativePlaceProvinceName + form.tbNativePlaceCityName + form.tbNativePlaceAreaName
      } else {
        form.tbNativePlace = '-'
      }
      form.tbHukou = null
      if (form.tbHukouAreaName) {
        form.tbHukou = form.tbHukouProvinceName + form.tbHukouCityName + form.tbHukouAreaName
      } else {
        form.tbHukou = '-'
      }
      form.tbCurrentPlace = null
      if (form.tbCurrentPlaceAreaName) {
        form.tbCurrentPlace = form.tbCurrentPlaceProvinceName + form.tbCurrentPlaceCityName + form.tbCurrentPlaceAreaName
      } else {
        form.tbCurrentPlace = '-'
      }
      form.tbRecuperate = null
      if (form.tbRecuperateAreaName) {
        form.tbRecuperate = form.tbRecuperateProvinceName + form.tbRecuperateCityName + form.tbRecuperateAreaName
      } else {
        form.tbRecuperate = '-'
      }

      if (form.healthlVo.tbDeviceHeartRate) {
        if (Number(form.healthlVo.tbDeviceHeartRate.tbValue) > 60 && Number(form.healthlVo.tbDeviceHeartRate.tbValue) < 100) {
          form.healthlVo.tbDeviceHeartRate.statusName = '正常'
          form.healthlVo.tbDeviceHeartRate.status = 1
        } else if (Number(form.healthlVo.tbDeviceHeartRate.tbValue) <= 60) {
          form.healthlVo.tbDeviceHeartRate.statusName = '偏低'
          form.healthlVo.tbDeviceHeartRate.status = 0
        } else {
          form.healthlVo.tbDeviceHeartRate.statusName = '偏高'
          form.healthlVo.tbDeviceHeartRate.status = 0
        }
      }
      if (form.healthlVo.tbDeviceBloodGlucose) {
        if (Number(form.healthlVo.tbDeviceBloodGlucose.tbValue) >= 3.9 && Number(form.healthlVo.tbDeviceBloodGlucose.tbValue) <= 6.1) {
          form.healthlVo.tbDeviceBloodGlucose.statusName = '正常'
          form.healthlVo.tbDeviceBloodGlucose.status = 1
        } else if (Number(form.healthlVo.tbDeviceBloodGlucose.tbValue) < 3.9) {
          form.healthlVo.tbDeviceBloodGlucose.statusName = '偏低'
          form.healthlVo.tbDeviceBloodGlucose.status = 0
        } else {
          form.healthlVo.tbDeviceBloodGlucose.statusName = '偏高'
          form.healthlVo.tbDeviceBloodGlucose.status = 0
        }
      }
      if (form.healthlVo.tbDeviceBloodOxygen) {
        if (Number(form.healthlVo.tbDeviceBloodOxygen.tbValue) >= 95) {
          form.healthlVo.tbDeviceBloodOxygen.statusName = '正常'
          form.healthlVo.tbDeviceBloodOxygen.status = 1
        } else {
          form.healthlVo.tbDeviceBloodOxygen.statusName = '偏低'
          form.healthlVo.tbDeviceBloodOxygen.status = 0
        }
      }
      if (form.healthlVo.tbDeviceBloodPressure) {
        if (Number(form.healthlVo.tbDeviceBloodPressure.tbSystolic) >= 140 || Number(form.healthlVo.tbDeviceBloodPressure.tbDiastolic) >= 90) {
          form.healthlVo.tbDeviceBloodPressure.statusName = '偏高'
          form.healthlVo.tbDeviceBloodPressure.status = 0
        } else if (Number(form.healthlVo.tbDeviceBloodPressure.tbSystolic) < 90 || Number(form.healthlVo.tbDeviceBloodPressure.tbDiastolic) < 60) {
          form.healthlVo.tbDeviceBloodPressure.statusName = '偏低'
          form.healthlVo.tbDeviceBloodPressure.status = 0
        } else {
          form.healthlVo.tbDeviceBloodPressure.statusName = '正常'
          form.healthlVo.tbDeviceBloodPressure.status = 1
        }
      }

      if (form.healthlVo.tbDeviceSleep) {
        form.healthlVo.tbDeviceSleep.timeLength = this.msToHoursRounded(new Date(form.healthlVo.tbDeviceSleep.tbEndTime.replace(/-/g, '/')).getTime() - new Date(form.healthlVo.tbDeviceSleep.tbStartTime.replace(/-/g, '/')).getTime())
      }

      if (form.healthlVo.tbDeviceUricAcid) {
        if (Number(form.healthlVo.tbDeviceUricAcid.tbValue) >= 60 && Number(form.healthlVo.tbDeviceUricAcid.tbValue) <= 360) {
          form.healthlVo.tbDeviceUricAcid.statusName = '正常'
          form.healthlVo.tbDeviceUricAcid.status = 1
        } else if (Number(form.healthlVo.tbDeviceUricAcid.tbValue) <= 60) {
          form.healthlVo.tbDeviceUricAcid.statusName = '偏低'
          form.healthlVo.tbDeviceUricAcid.status = 0
        } else {
          form.healthlVo.tbDeviceUricAcid.statusName = '偏高'
          form.healthlVo.tbDeviceUricAcid.status = 0
        }
      }

      if (form.healthlVo.tbDeviceBloodFat) {
        if (Number(form.healthlVo.tbDeviceBloodFat.tbValue) <= 5.2) {
          form.healthlVo.tbDeviceBloodFat.statusName = '正常'
          form.healthlVo.tbDeviceBloodFat.status = 1
        } else {
          form.healthlVo.tbDeviceBloodFat.statusName = '偏高'
          form.healthlVo.tbDeviceBloodFat.status = 0
        }
      }

      if (form.healthlVo.tbDeviceTemperature) {
        if (Number(form.healthlVo.tbDeviceTemperature.tbValue) <= 37.3) {
          form.healthlVo.tbDeviceTemperature.statusName = '正常'
          form.healthlVo.tbDeviceTemperature.status = 1
        } else if (Number(form.healthlVo.tbDeviceTemperature.tbValue) <= 38.1) {
          i.statusName = '低烧'
          i.status = 2
        } else {
          form.healthlVo.tbDeviceTemperature.statusName = '偏高'
          form.healthlVo.tbDeviceTemperature.status = 0
        }
      }
      return form;
    },
    msToHoursRounded (ms) {
      return Math.round(ms / (1000 * 60 * 60) * 10) / 10;
    },
    getById (id) {
      this.$http.get(`/${controller}/findPatientById`, { tbId: id }).then((res) => {
        if (res.code === 1000) {
          this.form = this.initForm(res.data);
          if (this.originRiskTree.length > 0) {
            this.initRisk()
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    initRisk () {
      const idList = this.form.tbRiskList.map(i => i.tbRiskAssessmentId)
      this.riskTree = this.originRiskTree.filter(j => {
        j.list = j.list.filter(i => idList.includes(i.tbId))
        return j.list.length
      })
    },
    getRiskTree () {
      this.$http.get(`/user/getRiskTree`, { tbId: this.$route.query.tbId }).then((res) => {
        if (res.code === 1000) {
          this.originRiskTree = res.data
          if (this.form?.phone) {
            this.initRisk()
          }
        }
      })
    },
    returnList () {
      this.closeTab(
        this.filePath,
        parentName,
        this.fileName,
        ['', ...suffixList].join('/'),
        true
      );
    }
  },
  created () {
    this.init();
    this.getRiskTree()
  },
  destroyed () { },
  components: {
    baseInfo,
    recordInfo,
    babyInfo,
    riskInfo,
    healthInfo
  }
};
</script>

<style lang="scss" scoped>
.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    overflow-x: auto;
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-motherDetail {
      padding-top: 4px;
      .addButton {
        cursor: pointer;
        margin-top: 5px;
        margin-bottom: 24px;
        margin-left: 170px;
        width: 645px;
        height: 32px;
        border-radius: 2px;
        border: 1px dashed rgba(0, 0, 0, 0.25);
        font-size: 14px;
        background-color: rgba(245, 245, 245, 1);
        color: #999999;
        display: block;
        &:focus {
          outline: none;
        }
        .margin11 {
          margin-right: 11px;
        }
      }
      ::v-deep .el-form-item {
        margin-bottom: 24px;
        .ui-box-tableList-img {
          width: 80px;
          height: 80px;
          background: #d8d8d8;
          display: inline-block;
          vertical-align: top;
        }
        &.inline {
          display: inline-block;
          vertical-align: top;
        }
        &.height-auto {
          ::v-deep .el-form-item__content {
            height: auto;
          }
        }

        ::v-deep .el-form-item__label {
          height: 32px;
          line-height: 32px;
          padding: 0;
          margin: 0;
        }
        ::v-deep .el-form-item__error {
          padding-left: 20px;
        }
        ::v-deep .el-form-item__content {
          height: 100%;
          padding-left: 20px;
          line-height: 32px;
        }
        .ui-box-from-motherDetail-text {
          cursor: pointer;
          line-height: 32px;
          display: inline-block;
          vertical-align: top;
          height: 100%;
          width: 48px;
        }
        .width645 {
          width: 645px;
        }
        .margin40 {
          margin-right: 40px;
        }
        .width761 {
          width: 761px;
        }

        .ui-box-from-motherDetail-input {
          width: 275px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          &.width645 {
            width: 645px;
          }
          ::v-deep .el-icon-time,
          ::v-deep .el-icon-arrow-down,
          ::v-deep .el-icon-arrow-up,
          ::v-deep .el-icon-date,
          ::v-deep .el-icon-date,
          ::v-deep .el-range__icon,
          ::v-deep .el-range-separator,
          ::v-deep .el-range-input,
          ::v-deep .el-range__close-icon,
          ::v-deep .el-icon-circle-close,
          ::v-deep .el-icon-arrow-up,
          ::v-deep .el-icon-date,
          ::v-deep .el-input__inner {
            vertical-align: top;
            height: 30px;
            line-height: 30px;
            border: none;
          }
          ::v-deep .el-input__inner::-webkit-outer-spin-button,
          // eslint-disable-next-line no-irregular-whitespace
          ::v-deep .el-input__inner::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          ::v-deep .el-input__inner[type="number"] {
            -moz-appearance: textfield;
          }
          ::v-deep .el-input-group__append {
            height: 30px;
            border: none;
            &::-moz-placeholder,
            &::-webkit-input-placeholder,
            &::-ms-input-placeholder {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #cccccc;
            }
          }
          ::v-deep .el-input-group__append {
            padding: 0 15px;
          }
        }
        .ui-box-from-motherDetail-button {
          margin-left: 20px;
          vertical-align: top;
          padding: 8px 32px;
          border-radius: 3px;
          &:focus {
            outline: none;
          }
        }
        .ui-box-from-motherDetail-img {
          cursor: pointer;
          line-height: 32px;
          margin-right: 8px;
        }
        .ui-box-from-motherDetail-text {
          cursor: pointer;
          line-height: 32px;
          display: inline-block;
          vertical-align: middle;
          height: 100%;
          margin-right: 30px;
        }
      }
    }
    .ui-box-motherDetail-button {
      margin-left: 217px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
      .submit {
        margin-left: 0;
        padding: 6px 25px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}

.ui-content {
  width: 100%;
  height: 100%;
  .ui-box {
    margin: 0 24px;
    padding-bottom: 24px;
    width: calc(100% - 48px);
    min-height: calc(100% - 24px);
    height: auto;
    background: #ffffff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    .ui-box-from-motherDetail {
      padding-top: 4px;
      ::v-deep .el-form-item {
        margin-bottom: 24px;
        .el-form-item__label {
          height: 32px;
          line-height: 32px;
          padding: 0;
          margin: 0;
        }
        .el-form-item__content {
          height: 100%;
          padding-left: 20px;
          line-height: 32px;
        }
        .ui-box-from-motherDetail-text {
          cursor: pointer;
          line-height: 32px;
          display: inline-block;
          vertical-align: top;
          height: 100%;
          width: 48px;
        }
        .width645 {
          width: 645px;
        }
        .margin40 {
          margin-right: 40px;
        }
        .el-form-item__error {
          padding-left: 20px;
        }
        .ui-box-from-motherDetail-input {
          width: 275px;
          height: 32px;
          background: #ffffff;
          border-radius: 2px;
          border: 1px solid rgba(0, 0, 0, 0.15);
          &.width645 {
            width: 645px;
          }
          .el-icon-time,
          .el-icon-arrow-down,
          .el-icon-arrow-up,
          .el-icon-date,
          .el-icon-date,
          .el-range__icon,
          .el-range-separator,
          .el-range-input,
          .el-icon-circle-close,
          .el-icon-arrow-up,
          .el-icon-date,
          .el-input__inner {
            vertical-align: top;
            height: 30px;
            line-height: 30px;
            border: none;
          }
          .el-input__inner::-webkit-outer-spin-button,
          // eslint-disable-next-line no-irregular-whitespace
          .el-input__inner::-webkit-inner-spin-button {
            -webkit-appearance: none;
          }
          .el-input__inner[type="number"] {
            -moz-appearance: textfield;
          }
          .el-input-group__append {
            height: 30px;
            border: none;
            &::-moz-placeholder,
            &::-webkit-input-placeholder,
            &::-ms-input-placeholder {
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #cccccc;
            }
          }
          .el-input-group__append {
            padding: 0 15px;
          }
        }
        .ui-box-from-motherDetail-button {
          margin-left: 20px;
          vertical-align: top;
          padding: 8px 32px;
          border-radius: 3px;
          &:focus {
            outline: none;
          }
        }
      }
    }
    .ui-box-motherDetail-button {
      margin-left: 217px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #555555;
      .return {
        padding: 6px 25px;
        margin-right: 40px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
      .submit {
        margin-left: 0;
        padding: 6px 25px;
        border-radius: 3px;
        border: 1px solid rgba(0, 0, 0, 0.15);
        line-height: 22px;
        &:focus {
          outline: none;
        }
      }
    }
  }
}
</style>